import { defineStore } from "pinia";
// import useConfigStore from "@/stores/config"
import { getMenuList } from "@/api/admin";
import { toTreeArray } from "xe-utils";
// const configStore = useConfigStore()
const prefix = '/unify';
const routeTable = ref([]);
const routeTree = ref([]);
const routeLoaded = ref(false);
const getRouteTable = async () => {
  const route = await getMenuList({
    parentId: prefix
  });
  routeTable.value = toTreeArray(route || [], {
    clear: true
  }) || [];
  routeTree.value = route || [];
  routeLoaded.value = true;
};
const hasPermission = async route => {
  console.log('hasPermission', route);
  return routeTable.value.some(item => item.path === `${prefix}${route.path}`);
};
const getChildren = route => {
  if (!route?.path) return [];
  return routeTable.value.filter(item => item.parentId === `${prefix}${route.path}`);
};
const getRoutePath = route => {
  return route.path.replace(prefix, '');
};
export default defineStore("permission", () => {
  return {
    prefix,
    routeTable,
    routeLoaded,
    getRouteTable,
    hasPermission,
    getChildren,
    getRoutePath
  };
});